import React from 'react';
import styles from './Footer.module.css';

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerBottom}>
          <div className={styles.footerAddress}>
            Address: 3911 Concord Pike #8030, SMB#27548, Wilmington, DE 19803, USA
          </div>
          <div className={styles.footerLinks}>
            <a href="agreement.html" rel="noopener noreferrer" className={styles.footerLink}>Terms of Service</a>
            <span className={styles.divider}>|</span>
            <a href="privacy.html" rel="noopener noreferrer" className={styles.footerLink}>Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 